module.exports = __webpack_public_path__ + "img/czzn_039.3db520ca.png";